import * as React from 'react';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { bindActionCreators } from 'redux';

import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { selectSpaceInfo } from '../../app/selectors/SpaceInfoSelectors';
import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { ChannelTypes } from '../../home/types/ChannelTypes';
import { fetchStarterInfoRequestedAction } from '../actions/StartersActions';
import { Starter, StartersGroupedByConnectionType } from '../types/StartersTypes';
import { CONNECTOR_SORTED_LIST_FOR_CHANNEL } from '../utils/constants';
import {
  StarterCardChannel,
  StarterCardChannelDispatchProps,
  StarterCardChannelProps,
  StartersCardChannelOwnProps,
} from './StartersCardChannel';

//TODO I prefer using a map here to avoid O(m * n). Create a map from connectionTypes with false for its values, then iterate over the starters while checking the map for and existing key. If it's there and false then push and set it to true.
function getFirstStarterOfEachType(starters: Starter[], connectionTypes: string[]): Starter[] {
  let startersOutput: Starter[] = [];
  connectionTypes.forEach(connectionType => {
    const starter = starters.find((starter) => starter.connectionType.internalName === connectionType);
    if (starter) {
      startersOutput.push(starter);
    }
  });
  return startersOutput;
}

export function getStartersGroupedByConnectionType(starters: Starter[]): StartersGroupedByConnectionType {
  let startersByConnection: StartersGroupedByConnectionType = {};
  starters.forEach(starter => {
    if (starter.connectionType.internalName in startersByConnection) {
      startersByConnection[starter.connectionType.internalName].push(starter);
    }
    else {
      startersByConnection[starter.connectionType.internalName] = [starter];
    }
  });
  return startersByConnection;
}

function getStarterTypesNotOnList(starters: Starter[], connectionTypes: string[]): string[] {
  let connectionTypesOutput = new Set<string>([]);
  let internalConnectionTypes = new Set<string>(connectionTypes.slice());
  starters.forEach(starter => {
    if (!internalConnectionTypes.has(starter.connectionType.internalName) &&
      !connectionTypesOutput.has(starter.connectionType.internalName)){
      connectionTypesOutput.add(starter.connectionType.internalName);
    }
  });
  return Array.from(connectionTypesOutput);
}

function getOneStarterOfEachConnectionType(starters: Starter[]): ReadonlyArray<Starter> {
  let startersOutput: Starter[] = [];
  if (starters.length > 0)
  {
    startersOutput = getFirstStarterOfEachType(starters, CONNECTOR_SORTED_LIST_FOR_CHANNEL);
    startersOutput.concat(getFirstStarterOfEachType(starters, getStarterTypesNotOnList(starters, CONNECTOR_SORTED_LIST_FOR_CHANNEL)));
  }
  return startersOutput;
}

const mapStateToProps: (appState: AppState, props: StartersCardChannelOwnProps) => StarterCardChannelProps = (appState: AppState, props: StartersCardChannelOwnProps) => {
  const siteUrls = siteUrlsSelector(appState);
  const starterChannelProps: StarterCardChannelProps = {
    channelType: ChannelTypes.starters,
    title: Messages.startersChannelTitle(),
    description: Messages.startersChannelDescription(),
    seeAllUrl: siteUrls.startersByConnectionTypeUrl('all'),
    seeAllAltText: Messages.StartersSeeAllLinkAltText(),
    list: getOneStarterOfEachConnectionType(appState.starters.starters),
    isFetching: false,
    numRows: 2,
    maxCardsPerRow: props.maxCardsPerRow,
    spaceInfo: selectSpaceInfo(appState),
    startersGroupedByConnectionType: getStartersGroupedByConnectionType(appState.starters.starters),
    moreLikeThisLink: siteUrls.startersUrl(),
  };
  return starterChannelProps;
};

const mapDispatchToProps: MapDispatchToProps<StarterCardChannelDispatchProps, null> =
  (dispatch) => bindActionCreators({
      fetchStartersData: fetchStarterInfoRequestedAction,
  },
  dispatch);

export const ConnectedStartersChannel = connect(mapStateToProps, mapDispatchToProps)(StarterCardChannel);
